import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { deepEqual } from 'fast-equals';

export interface DirtyCheckConfig {
  enabled?: boolean;
  withDisabled?: boolean;
}

const defaults: DirtyCheckConfig = {
  enabled: true,
  withDisabled: true,
};

export function getControlValue(control: AbstractControl, withDisabled: boolean) {
  if (withDisabled && (control instanceof FormGroup || control instanceof FormArray)) {
    return control.getRawValue();
  }
  return control.value;
}

export function dirtyFormCheck<U, Config extends DirtyCheckConfig>(
  control: AbstractControl,
  initialValue: U,
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  config: Config = {} as Config,
): boolean {
  const { enabled, withDisabled } = {
    ...defaults,
    ...config,
  };

  if (!enabled) {
    return false;
  }

  const formValue = getControlValue(control, withDisabled ?? true);

  const isFormStateDirty = control.dirty;
  const isValueDifferent = !deepEqual(initialValue, formValue);

  return isFormStateDirty && isValueDifferent;
}
